import { supabase } from '../client';

export interface RequisitionHistoryEntry {
  id: string;
  org_id: string;
  requisition_id: string;
  from_status: string | null;
  to_status: string;
  changed_by: string | null;
  changed_by_id: string | null;
  note: string | null;
  changed_at: string;
}

export const requisitionHistoryService = {
  async listByRequisition(requisitionId: string): Promise<RequisitionHistoryEntry[]> {
    const { data, error } = await supabase
      .from('ggj_b2b_requisition_status_history')
      .select('*')
      .eq('requisition_id', requisitionId)
      .order('changed_at', { ascending: false });
    if (error) {
      if (error.code === 'PGRST205') return [];
      throw error;
    }
    return (data ?? []) as RequisitionHistoryEntry[];
  },

  async record(
    orgId: string,
    requisitionId: string,
    fromStatus: string | null,
    toStatus: string,
    opts?: { changedBy?: string; changedById?: string | null; note?: string }
  ): Promise<void> {
    const { error } = await supabase
      .from('ggj_b2b_requisition_status_history')
      .insert({
        org_id: orgId,
        requisition_id: requisitionId,
        from_status: fromStatus,
        to_status: toStatus,
        changed_by: opts?.changedBy ?? null,
        changed_by_id: opts?.changedById ?? null,
        note: opts?.note ?? null,
      });
    if (error) throw error;
  },
};
